import type { FC } from 'react';

import type { WorkProject } from '../../types';

interface SummarySectionProps {
  project: WorkProject;
}

const SummarySection: FC<SummarySectionProps> = ({ project }) => (
  <section className="font-montreal text-zinc-800 dark:text-white/80">
    <div className="mx-auto w-full max-w-[96rem] px-6 text-zinc-900 sm:px-10 lg:px-16 dark:text-white">
      <div className="grid gap-12 md:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)]">
        <div className="space-y-10">
          <p className="text-3xl font-light leading-tight text-zinc-900 sm:text-4xl dark:text-white">
            {project.headline ?? project.description ?? project.quote}
          </p>
          {project.okrs.slice(0, 2).length > 0 && (
            <div className="grid grid-cols-2 gap-8">
              {project.okrs.slice(0, 2).map((okr) => (
                <div key={okr.label} className="text-left">
                  <div className="font-konexy text-[3.25rem] leading-none uppercase tracking-tight text-zinc-900 dark:text-white">
                    {okr.value}
                  </div>
                  <div className="mt-2 text-xs font-semibold uppercase tracking-[0.32em] text-zinc-500 dark:text-white/60">
                    {okr.label}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="ml-auto max-w-[450px] space-y-5 text-left text-zinc-700 dark:text-white/80">
          {project.summary.map((paragraph, index) => (
            <p key={index} className="text-[1.25rem] leading-relaxed">
              {paragraph}
            </p>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default SummarySection;
